module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMTAgMTEwIj48ZGVmcz48c3R5bGU+LmEsLmN7ZmlsbDpub25lfS5ie29wYWNpdHk6LjY3fS5je3N0cm9rZTojZmZmO3N0cm9rZS1saW5lY2FwOnJvdW5kO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2Utd2lkdGg6N3B4fTwvc3R5bGU+PC9kZWZzPjx0aXRsZT50cmVuZC11cDwvdGl0bGU+PHBhdGggY2xhc3M9ImEiIGQ9Ik0wIDBoMTEwdjExMEgweiIvPjxnIGNsYXNzPSJiIj48cGF0aCBjbGFzcz0iYyIgZD0iTTkxLjM2IDE4LjY0TDIwLjY0IDg5LjM2bTguNDktNzAuNzJoNjIuMjN2NjIuMjMiLz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/images/trend-up.svg
// module id = 282
// module chunks = 1